module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9365/js/img/CMSHub_Icon.svg"